import React, { useState } from 'react';

import { Comment, Comments } from '@amzn/coral_com-amazon-musicpapercontractconfigurationservice';
import Column from '@amzn/meridian/column';
import Heading from '@amzn/meridian/heading';
import Row from '@amzn/meridian/row';

import { CommentInput } from '../CommentInput';
import { CommentList } from '../CommentList';
import { CommentSearch } from '../CommentSearch';

interface ICommentSectionProps {
    category: string;
    categoryUniqueColumnId: number;
    title?: string;
    showTitle?: boolean;
    showSearch?: boolean;
    showInput?: boolean;
    disableInput?: boolean;
    inputButtonText?: string;
    inputPlaceholder?: string;
    searchPlaceholder?: string;
    emptyStateMessage?: string;
    noResultsMessage?: string;
}

export const CommentSection = ({
    category,
    categoryUniqueColumnId,
    title = 'Comments',
    showTitle = true,
    showSearch = true,
    showInput = true,
    disableInput = true,
    inputButtonText = 'Add Comment',
    inputPlaceholder = 'Add a comment...',
    searchPlaceholder = 'Search comments...',
    emptyStateMessage = 'No comments yet',
    noResultsMessage = 'No comments match your search'
}: ICommentSectionProps) => {
    const [searchQuery, setSearchQuery] = useState('');
    const [comments, setComments] = useState<Comments>([]);

    const filteredCommentsCount = comments.filter(
        (comment) => !searchQuery.trim() || comment.comment?.toLowerCase().includes(searchQuery.toLowerCase())
    ).length;

    // Handle adding a new comment
    const handleCommentAdded = (newComment: Comment) => {
        setComments((prevComments) => [newComment, ...prevComments]);
    };

    return (
        <>
            <Column>
                {showTitle && (
                    <Row spacing="200">
                        <Heading level={4}>{title}</Heading>
                    </Row>
                )}

                {showSearch && (
                    <CommentSearch
                        searchQuery={searchQuery}
                        onSearchChange={setSearchQuery}
                        placeholder={searchPlaceholder}
                        filteredCount={filteredCommentsCount}
                        totalCount={comments.length}
                        title={title.toLocaleLowerCase()}
                    />
                )}

                {showInput && (
                    <CommentInput
                        category={category}
                        categoryUniqueColumnId={categoryUniqueColumnId}
                        onCommentAdded={handleCommentAdded}
                        disableCommentInput={disableInput}
                        buttonText={inputButtonText}
                        placeholder={inputPlaceholder}
                    />
                )}

                <CommentList
                    category={category}
                    categoryUniqueColumnId={categoryUniqueColumnId}
                    searchQuery={searchQuery}
                    emptyStateMessage={emptyStateMessage}
                    noResultsMessage={noResultsMessage}
                    comments={comments}
                    setComments={setComments}
                />
            </Column>
        </>
    );
};
